
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/membership/help",
      function () {
        return require("private-next-pages/about/membership/help.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/membership/help"])
      });
    }
  